import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { TextureInput } from '@src/app/generated/globalTypes';
import { Asset, Id, Texture } from '@ess/jg-rule-executor';
import { GetAllTextures_allTextures_edges_node } from '@src/app/generated/GetAllTextures';

export class PortalModuleTexture extends Texture implements ToJsonInputTranslatable {
  constructor(
    id: Id<Texture>,
    name: string,
    asset?: Asset
  ) {
    super(
      id,
      name,
      asset
    );
  }

  static fromGql(gql: GetAllTextures_allTextures_edges_node): PortalModuleTexture {
    return new PortalModuleTexture(
      gql.id,
      gql.name,
      gql.asset
    );
  }

  toGqlInput(): TextureInput {
    return {
      name: this.name,
    };
  }

  static toJsonInput(textureInput: TextureInput): JSON {
    return { texture: textureInput } as object as JSON;
  }
}
